import React from 'react';
import IntlMessages from 'util/IntlMessages';
import UserAvatar from 'components/UserAvatar';

const UserInfo = ({ user, onSignOut, toUserProfile, toUserSettings }) => {
	const { firstName, lastName, userName, avatar } = user;
	return (
		<div>
			<div className="user-profile">
				<UserAvatar avatar={avatar} size={40} />
				<div className="user-detail ml-2">
					<h4 className="user-name mb-0">{`${firstName} ${lastName}`}</h4>
					<small>{userName}</small>
				</div>
			</div>
			<span className="dropdown-item text-muted pointer" onClick={toUserProfile}>
				<i className="zmdi zmdi-face zmdi-hc-fw mr-1" />
				<IntlMessages id="header.user.profile" />
			</span>
			<span className="dropdown-item text-muted pointer" onClick={toUserSettings}>
				<i className="zmdi zmdi-settings zmdi-hc-fw mr-1" />
				<IntlMessages id="header.user.settings" />
			</span>
			<span className="dropdown-item text-muted pointer" onClick={onSignOut}>
				<i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
				<IntlMessages id="header.user.logout" />
			</span>
		</div>
	);
};

export default UserInfo;



// WEBPACK FOOTER //
// ./containers/Header/Component/UserInfo.js